module.exports = __webpack_public_path__ + "media/images/scrolldown-f636c6063573e534f771fda01ecce79a.gif";